import { chain } from '@leprecoins/effector';
import { createAddAccountModel } from 'features/add-account';
import { createBlockAccountModel } from 'features/block-account';
import { createDeleteAccountModel } from 'features/delete-account';
import { createEditAccountModel } from 'features/edit-account';
import { createUnblockAccountModel } from 'features/unblock-account';
import { accountTreeModel, createAccountRegistryModel } from 'entities/account';

const addAccountModel = createAddAccountModel();

const editAccountModel = createEditAccountModel();

const blockAccountModel = createBlockAccountModel();

const unblockAccountModel = createUnblockAccountModel();

const deleteAccountModel = createDeleteAccountModel();

const accountRegistryModel = createAccountRegistryModel({
	onUpdate: [
		addAccountModel.addAccountMutation.finished.success,
		blockAccountModel.mutation.finished.success,
		unblockAccountModel.mutation.finished.success,
		editAccountModel.editAccountMutation.finished.success,
	],
	onDelete: [deleteAccountModel.mutation.finished.success],
});

chain(deleteAccountModel.mutation.finished.success, accountTreeModel.fetch);

export const accountsPageModel = {
	addAccountModel,
	editAccountModel,
	deleteAccountModel,
	accountRegistryModel,
	blockAccountModel,
	unblockAccountModel,
};
